<template>
  <gj-table
      ref="gjTable"
      adaptParent
      :index="false"
      :loading="loading"
      :data="tableData"
      :columns="columns"
      :offset-height="40"
      :show-overflow="false"
      :pagination="pagination"
      @page-change="$gjQuery">
      <!-- 操作对象 -->
    <template v-slot:objectName="{row}">
        <div>
          <div>{{optionMap[row.objectType] | defaultShow}}</div>
           <div style="margin-top: 2px">{{row.objectName}}</div>
        </div>
    </template>
    <template v-slot:campaignName="{row}">
      <div>{{row.campaignName | defaultShow}}</div>
    </template>
     <template v-slot:groupName="{row}">
      <div>{{row.groupName | defaultShow}}</div>
    </template>
     <template v-slot:operationContentType="{row}">
      <div >{{optionMap[row.operationContentType] | defaultShow}}</div>
    </template>
    <template v-slot:logTemplateList="{row}">
       <template v-if="row.logTemplateList === null">-</template>
       <template v-else>
        <gj-popover trigger="hover" placement="bottom" width="1000">
                <template>
                    <gj-table
                        :columns="ruleColumns"
                        ref="gjTable"
                        :index="false"
                        :adapt-height="false"
                        :height="180"
                        name="maxNumTable"
                        :data="row.logTemplateList"
                        :show-overflow="false"
                    >
                    <template v-slot:applyObjectName="{row}">
                      <div >{{optionMap[row.applyObjectAdsType] | defaultShow}}</div>
                      <div style="magin: 0;color: #1F6EEF">{{row.applyObjectName}}</div>
                    </template>
                     <template v-slot:executeObjectAdsType="{row}">
                      <div>{{optionMap[row.executeObjectAdsType] | defaultShow}}</div>
                    </template>
                     <template v-slot:templateObject="{row}">
                      {{getContent(row.templateObject.expressionVO)}}
                    </template>
                     <template v-slot:currentPerformanceList="{row}">
                      {{getInfo(row.currentPerformanceList)}}
                    </template>

                     
                    </gj-table>
                  <div slot="reference" class="rule">
                    <div style="margin: 0; max-width: 130px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{getRuleTemplateContent(row)}}</div>
                    <i class="el-icon-arrow-down"></i>
                  </div> 
                </template>

              </gj-popover>

       </template>
      

    </template>
    <!--            操作-->
    <template v-slot:source="{ row }">
      {{operationContent(row)}}
    </template>
    <!--            操作结果-->
    <template v-slot:result="{ row }">
      <div :style="{color: (row.result === 'success' ? '#2DA641' : 'red')}">
        {{ row.result === 'success' ? "成功" : "失败"  }}
        <gj-tooltip v-if="row.result === 'failure'" :content="row.detail">
          <i class="el-icon-arrow-down"></i>
        </gj-tooltip>
      </div>
    </template>

  </gj-table>
</template>

<script>
import {AdLog} from "@/views/modules/ad/common/enum";
import {getAutoRuleObjectLogPageData} from "@/api/ad";
import {queryMixin, isMeaningfulMixin} from "@/minxins";
import {isMeaningful} from "@/utils/common";
import { mapGetters } from "vuex";
import {optionMap, option, getRuleContent, getRuleInfo} from "@/views/modules/ad/ad-automate/const"

export default {
  name: "automatic-rule-table",
  mixins: [queryMixin, isMeaningfulMixin],
  computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
  },
  filters: {
    optionsText(val, options) {
      const item = options.find(e => e.id == val);
      return item ? item.text : val
    },
  },
  props:{
    model:{
      type: Object,
      default:()=>{}
    }
  },
  data(){
    return {
      optionMap,
      option,
      tableData: [],
      columns: [
        {id: 'operationMarketTime', header: '操作时间（站点时间）', field: 'operationMarketTime', minWidth: '150px', overflowLine: 1},
        {id: 'marketId', header: '站点', field: 'option:marketId', minWidth: '100px', options: () => this.marketOption, overflowLine: 1},
        {id: 'objectName', header: '操作对象', field: 'slot:objectName', minWidth: '140px', },
        {id: 'campaignName', header: '广告活动', field: 'slot:campaignName', minWidth: '140px', },
        {id: 'groupName', header: '广告组', field: 'slot:groupName', minWidth: '140px', },
        {id: 'logTemplateList', header: '模板/规则', field: 'slot:logTemplateList', width: '130px',},
        {id: 'operationContentType', header: '操作类型', field: 'slot:operationContentType', minWidth: '100px', overflowLine: 1},
        {id: 'source', header: '操作', field: 'slot:source', minWidth: '120px', overflowLine: 1},
        {id: 'result', header: '操作结果', field: 'slot:result', minWidth: '80px', overflowLine: 1},
        {id: 'operationTime', header: '操作时间（北京时间）', field: 'operationTime', minWidth: '150px', overflowLine: 1},
      ],
      options: { // 枚举
        // 操作对象类型
        objectType: AdLog().objOptions,
        // 调整类型
        optOptions: AdLog().optOptions,
        // 操作结果
        resultOptions: AdLog().resultOptions,
      },
       ruleColumns: [
        {id: 'templateName', header: '模版/规则名称', field: 'templateName', minWidth: '100px', },
        {id: 'applyObjectName', header: '应用对象', field: 'slot:applyObjectName', minWidth: '120px', },
        {id: 'executeObjectAdsType', header: '优化对象', field: 'slot:executeObjectAdsType', minWidth: '100px', },
        {id: 'templateObject', header: '规则', field: 'slot:templateObject', minWidth: '200px',},
        {id: 'currentPerformanceList', header: '应用时数据', field: 'slot:currentPerformanceList', minWidth: '120px'},
      ],
    }
  },
  methods:{
   $gjQuery(){
      // 构造查询参数
      var info = {}
      if (this.model.createDateType === 0) {
        info = {
          marketIdList: this.model.marketIdList,
          executeObjectType: this.model.objectType,
          operationType: this.model.operateType,
          campaignIdList: this.model.campaignIds,
          groupIds: this.model.groupIds,
          objectName: this.model.objectName,
          startTime: this.model.startTime,
          endTime: this.model.endTime
        }
      }else {
         info = {
          marketIdList: this.model.marketIdList,
          executeObjectType: this.model.objectType,
          operationType: this.model.operateType,
          campaignIdList: this.model.campaignIds,
          groupIds: this.model.groupIds,
          objectName: this.model.objectName,
          marketStartTime: this.model.startTime,
          marketEndTime: this.model.endTime
        }
      }
      const params = {
        model: info,
        ...this.queryPagination,
        ...this.querySort
      };
      // 查询
      this.loading = true;
      getAutoRuleObjectLogPageData(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
    },
    //操作内容
    operationContent(row) {
       var content = '';
       if (row.source !== null && row.target !== null) {
         content = row.source + ' -> ' + row.target
       }else if (row.source !== null && row.target === null) {
         content = row.source;
       }else if (row.source === null && row.target !== null) {
         content = row.target;
       }else {
        content = '-';
       }
       return content;
   
      //  switch (row.operationContentType) {
      //     case 'addRule':  //新增规则
      //       return content = '新增自动化规则：' + (row.logTemplateList ? row.logTemplateList[0].templateName : '');
      //     case 'updateRule':  //更换规则
      //       return content = '更换规则：' + row.source + '->' + row.target;
      //     case 'updateState':  //修改状态
      //       return content = '状态变更：' + optionMap[row.source] + '->' + optionMap[row.target];
      //     case 'target':  //添加投放
      //       return  content = '设为【' + row.campaignName + '】,【' + row.groupName + '】的' + optionMap[row.objectType] + '(' + optionMap[row.matchType] + ')投放';
      //     case 'negativeTarget':  //添加否定投放
      //       return  content = '设为【' + row.campaignName + '】,【' + row.groupName + '】的否定' + optionMap[row.objectType];
      //     case 'parseTarget':  //暂停投放
      //       return content = '暂停' + optionMap[row.objectType];
      //     case 'adjustBudget':  //调整预算
      //       return content = row.source + '->' + row.target;
      //     case 'adjustBid':  //调整竞价
      //       return  content = row.source + '->' + row.target;
      //  }

    },
    //规则/模版
    getRuleTemplateContent(row) {
      if (isMeaningful(row.logTemplateList)) {
         const array = row.logTemplateList.map((e) => {
            return e.templateName;
         } );
         return array.toString();
      }else {
        return '-';
      }
    },
    //规则
     getContent(item) {
      return getRuleContent(item);
    },
    //应用时数据
     getInfo(item) {
      return getRuleInfo(item);
    },
  }
}
</script>

<style scoped>
.rule {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>